
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/expert/[...slug]",
      function () {
        return require("private-next-pages/expert/[...slug].tsx");
      }
    ]);
  